import styled from 'styled-components';
import { Button } from 'reactstrap';

export const TransferMultiplesChatsButtonAltIcon = styled(Button)`
  &:hover {
    transform: scale(1.1);
  }
`;
